import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import { TRACK_CENSORIOUS } from 'services/tracks/types';
import './CensoriousSelectCard.scss';

interface ICensoriousSelectCardProps {
  censorious: TRACK_CENSORIOUS;
  isSelected?: boolean;
  onClick?: (censorious: TRACK_CENSORIOUS) => void;
  disabled?: boolean;
}

const CensoriousSelectCard = ({
  censorious,
  isSelected,
  onClick,
  disabled,
}: ICensoriousSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('censorious-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(censorious)}
    >
      <div className="censorious-select-card-header">
        <div className="censorious-select-card-header-name">
          {t(`censorious.${TRACK_CENSORIOUS[censorious]}.name`)}
        </div>
        <div className="censorious-select-card-header-description">
          {t(`censorious.${TRACK_CENSORIOUS[censorious]}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default CensoriousSelectCard;
